import React from "react";

function AdminPromociones({
  promociones,
  productos,
  tipoPromo,
  setTipoPromo,
  productoDetonante,
  setProductoDetonante,
  productoRegalo,
  setProductoRegalo,
  minimoCompra,
  setMinimoCompra,
  handlePromoSubmit,
  cargandoPromo,
  handleEliminarPromo,
  handleTogglePromoActiva,
}) {
  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "24px",
        borderRadius: "16px",
        border: "1px solid #e2e2e2",
        boxShadow: "0 4px 12px rgba(0,0,0,0.02)",
      }}
    >
      <h3
        style={{
          margin: "0 0 5px 0",
          fontSize: "18px",
          fontWeight: "700",
          color: "#4a148c",
        }}
      >
        🎟️ Central de Promociones Automatizadas
      </h3>

      <p
        style={{
          color: "#666",
          fontSize: "13px",
          marginBottom: "20px",
        }}
      >
        Crea reglas de negocio automáticas.
      </p>

      <form
        onSubmit={handlePromoSubmit}
        style={{
          border: "1px solid #eee",
          padding: "16px",
          borderRadius: "12px",
          backgroundColor: "#fbf9ff",
          marginBottom: "25px",
        }}
      >
        <div
          style={{
            marginBottom: "12px",
          }}
        >
          <label
            style={{
              display: "block",
              fontSize: "13px",
              fontWeight: "700",
              marginBottom: "4px",
              color: "#4a148c",
            }}
          >
            Mecánica:
          </label>

          <select
            value={tipoPromo}
            onChange={(e) => setTipoPromo(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              backgroundColor: "#fff",
            }}
          >
            <option value="2x1">🍔 2x1</option>

            <option value="envio_gratis">🛵 Envío Gratis</option>

            <option value="regalo">🎁 Regalo</option>
          </select>
        </div>

        {tipoPromo === "2x1" && (
          <div
            style={{
              marginBottom: "14px",
            }}
          >
            <label
              style={{
                display: "block",
                fontSize: "13px",
                fontWeight: "600",
                marginBottom: "4px",
              }}
            >
              Producto:
            </label>

            <select
              value={productoDetonante}
              onChange={(e) => setProductoDetonante(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
              }}
            >
              <option value="">-- Selecciona --</option>

              {productos.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.nombre}
                </option>
              ))}
            </select>
          </div>
        )}

        {tipoPromo === "envio_gratis" && (
          <div
            style={{
              marginBottom: "14px",
            }}
          >
            <label
              style={{
                display: "block",
                fontSize: "13px",
                fontWeight: "600",
                marginBottom: "4px",
              }}
            >
              Compra mínima:
            </label>

            <input
              type="number"
              value={minimoCompra}
              onChange={(e) => setMinimoCompra(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #ccc",
              }}
            />
          </div>
        )}

        {tipoPromo === "regalo" && (
          <>
            <div
              style={{
                marginBottom: "12px",
              }}
            >
              <label
                style={{
                  display: "block",
                  fontSize: "13px",
                  fontWeight: "600",
                  marginBottom: "4px",
                }}
              >
                Producto detonante:
              </label>

              <select
                value={productoDetonante}
                onChange={(e) => setProductoDetonante(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              >
                <option value="">-- Selecciona --</option>

                {productos.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.nombre}
                  </option>
                ))}
              </select>
            </div>

            <div
              style={{
                marginBottom: "14px",
              }}
            >
              <label
                style={{
                  display: "block",
                  fontSize: "13px",
                  fontWeight: "600",
                  marginBottom: "4px",
                }}
              >
                Regalo:
              </label>

              <select
                value={productoRegalo}
                onChange={(e) => setProductoRegalo(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              >
                <option value="">-- Selecciona --</option>

                {productos.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.nombre}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}

        <button
          type="submit"
          disabled={cargandoPromo}
          style={{
            width: "100%",
            backgroundColor: "#4a148c",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            padding: "12px",
            fontSize: "15px",
            fontWeight: "700",
            cursor: "pointer",
          }}
        >
          {cargandoPromo ? "Guardando..." : "Activar Promoción"}
        </button>
      </form>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        {promociones.map((promo) => (
          <div
            key={promo.id}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px",
              border: "1px solid #e0d8f0",
              borderRadius: "10px",
              backgroundColor: "#fff",
            }}
          >
            <div style={{ flex: 1 }}>
              {promo.tipo === "2x1" && (
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  🔥 2x1: {promo.nombreProducto}
                </span>
              )}

              {promo.tipo === "envio_gratis" && (
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  🛵 Gratis desde ${promo.minimo}
                </span>
              )}

              {promo.tipo === "regalo" && (
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  🎁 {promo.regaloNombre}
                </span>
              )}
            </div>

            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <button
                type="button"
                onClick={() =>
                  handleTogglePromoActiva(promo.id, promo.activa !== false)
                }
                style={{
                  background: "none",
                  border: "none",
                  color: promo.activa !== false ? "#c5221f" : "#137333",
                  fontSize: "12px",
                  fontWeight: "700",
                  cursor: "pointer",
                }}
              >
                {promo.activa !== false ? "Apagar" : "Encender"}
              </button>

              <button
                type="button"
                onClick={() => {
                  const confirmar = window.confirm(
                    "¿Seguro que quieres borrar esta promoción definitivamente?",
                  );

                  if (confirmar) {
                    handleEliminarPromo(promo.id);
                  }
                }}
                style={{
                  background: "none",
                  border: "none",
                  color: "#777",
                  fontSize: "12px",
                  fontWeight: "700",
                  cursor: "pointer",
                }}
              >
                Borrar
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminPromociones;
